module.exports = __webpack_public_path__ + "static/media/selectarrow.d88a0056.svg";